import { render, staticRenderFns } from "./withdraw-approval-detail.vue?vue&type=template&id=139835fe&scoped=true&"
import script from "./withdraw-approval-detail.vue?vue&type=script&lang=js&"
export * from "./withdraw-approval-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-approval-detail.vue?vue&type=style&index=0&id=139835fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139835fe",
  null
  
)

export default component.exports